<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="d-flex align-center ga-1">
        <span class="text-disabled font-size-14">Виявлено недоліків:</span>
        <b>{{ audit.flaws?.length }}</b>
      </div>

      <v-btn
        v-if="audit.statusId === 2"
        color="black"
        rounded="lg"
        @click="createFlaw">
        <v-icon class="mr-2" icon="mdi-plus"></v-icon>
        <span>Додати факт недоліку</span>
      </v-btn>
    </div>

    <div v-if="audit.flaws?.length">
      <flaw-item
        v-for="(flaw, idx) in audit.flaws"
        :key="flaw.id"
        :flaw="flaw"
        :index="idx"
        class="mb-3"></flaw-item>
    </div>
    <div v-else class="d-flex flex-column align-center py-12">
      <search-icon class="mb-5"></search-icon>
      <h2 class="mb-3">Фактів недоліків не зафіксовано</h2>
      <div v-if="audit.statusId === 1" class="text-center">
        <div class="font-size-14 mb-5">
          Щоб додати факти недоліку, візьміть в роботу Аудит.
        </div>
        <v-btn
          :loading="$loading.isLoading('takeToWork')"
          density="comfortable"
          rounded="lg"
          width="140px"
          @click="takeToWork">
          Взяти в роботу
        </v-btn>
      </div>
      <div v-else class="font-size-14">
        Натисніть «Додати факт недоліку» для внесення першого
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAudit } from '../../index'
import FlawItem from './FlawItem.vue'
import SearchIcon from '@/assets/images/SearchIcon.vue'

export default {
  name: 'Flaws',
  components: { FlawItem, SearchIcon },
  setup() {
    return { ...useAudit() }
  },
}
</script>

<style lang="scss" scoped></style>
